import React from 'react';
import styled from 'styled-components';
import { IPartitionValueFieldsFragment } from '../../../utils/apollo/graphqlSchema';
import { compact, isNil } from 'lodash';
import { conversionWindowTimeUnitToText } from '../utils/partitionUtils';
import { UnreachableCaseError } from 'ts-essentials';

interface IProps {
  partitionValues: IPartitionValueFieldsFragment[];
}

const PartitionValue = styled.div`
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export default ({ partitionValues }: IProps) => {
  const list = partitionValues
    ?.map((pv) => {
      const partition = pv.partition;
      switch (partition.__typename) {
        case 'NonePartition':
        case 'FieldPartition':
          return partition.name;
        case 'ConversionWindowPartition':
          const conversionWindow = pv.conversionWindow;
          let duration: string | undefined;
          if (!isNil(conversionWindow)) {
            duration =
              conversionWindow.value +
              ' ' +
              conversionWindowTimeUnitToText(
                conversionWindow.timeUnit,
                conversionWindow.value,
              );
          }
          return compact([partition.name, duration]).join(' = ');
        default:
          throw new UnreachableCaseError(partition);
      }
    })
    .join(', ');
  return <PartitionValue>{list}</PartitionValue>;
};
